import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=4b4e2bde&lang=pug"
import script from "./menuItem.vue?vue&type=script&lang=coffee"
export * from "./menuItem.vue?vue&type=script&lang=coffee"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=4b4e2bde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports